module.exports = __webpack_public_path__ + "img/1530081457.0a25cdc9.jpg";